import * as React from 'react';
import { PK } from 'common/types';
import { useProgramDetails } from 'modules/programs/queries';

import { useSaveProgramBlog } from '../hooks';
import BlogsPicker from './BlogsPicker';

type Props = {
  pk?: PK;
};

const ProgramBlogPicker = ({ pk }: Props) => {
  const { data } = useProgramDetails(pk);
  const blog_pk = data?.blog_pk;
  const { save, isLoading, isError, isSuccess } = useSaveProgramBlog(pk);
  const saveStatus = { isLoading, isError, isSuccess };

  const handleSave = (blogsPks: PK[]) => {
    save(blogsPks, data);
  };

  return (
    <BlogsPicker blog_pk={blog_pk} pk={pk} onSave={handleSave} saveStatus={saveStatus} />
  );
};

export default ProgramBlogPicker;
